<template>
<div id="investor-update-page">
        <div class="updates-body">
            <section>
                <div class="investor-articles">
                    <InvestorArticleResult v-for="article in investorArticles" :key="article.article_id" :article="article"></InvestorArticleResult>
                </div>
            </section>
        </div>
    <Pagination :count="investorArticlesCount" :currentPage.sync="currentPage" :itemsPerPage="itemsPerPage"></Pagination>
</div>
</template>

<script>
import {
    mapGetters
} from "vuex";
import store from "@/store"
import InvestorArticleResult from "@/components/investments/InvestorArticleResult";
import KolkinSharesGraph from "@/components/investments/KolkinSharesGraph";
import Utility from "@/../submodules/vue-base/mixins/Utility";
import Pagination from "@/../submodules/vue-base/components/Pagination";
import Cover from "@/components/layout/Cover.vue";
import InvestorBody from "@/components/layout/InvestorBody.vue";

export default {
    name: "Updates",

    mixins: [
        Utility
    ],

    data() {
        return {
            itemsPerPage: 5,
            currentPage: 1,
        }
    },

    components: {
        KolkinSharesGraph,
        InvestorArticleResult,
        Pagination,
        Cover,
        InvestorBody,
    },

    beforeRouteEnter(to, from, next) {
        var page = 1;
        var obj = {
            offset: (page - 1) * 5,
            limit: 5,
        }

		store.dispatch("updateQuery", obj);

		store.dispatch("getInvestments").then(function () {
			store.dispatch("loadSharesData").then(function () {
				store.dispatch("loadInvestorArticles").then(function () {
					next();
				}).catch(function () {
					next({
						name: "home"
					})
				});
			});
		}).catch(function () {
			next({
				name: "home"
			})
		});

    },

    beforeRouteUpdate(to, from, next) {
        var page = 1;
        var obj = {
            offset: (page - 1) * 5,
            limit: 5,
        }

        if (store.state.user.user.is_investor == "t") {
            store.dispatch("updateQuery", obj);

            store.dispatch("getInvestments").then(function () {
                store.dispatch("loadSharesData").then(function () {
                    store.dispatch("loadInvestorArticles").then(function () {
                        next();
                    }).catch(function () {
                        next({
                            name: "home"
                        })
                    });
                });
            }).catch(function () {
                next({
                    name: "home"
                })
            });
        } else {
            next({
                name: "home"
            })
        }
    },

	mounted(){
		console.log(this.dayOfSharesData)
	},

    methods: {
        roundPrices(input) {
            var cents = input * 100; // ... is 7.5 cents
            var roundedCents = Math.round(cents); // ... but should really be 8 cents
            var roundedPrice = roundedCents / 100; // ... so it's 0.08 dollars in the end

            return roundedPrice
        },
    },

    watch: {
        currentPage() {
            var obj = {
                offset: this.itemsPerPage * (this.currentPage - 1),
                limit: this.itemsPerPage,
            }
            store.dispatch("updateQuery", obj);
            store.dispatch("loadInvestorArticles");
        }
    },

    computed: {
        currentShareValue() {
            if (this.dayOfSharesData.length == 0) {
                return 0;
            }
            return this.numberSetPrecision(this.dayOfSharesData[this.dayOfSharesData.length - 1].price_per_share, 2);
        },
		currentValuation(){

			if (this.dayOfSharesData.length == 0) {
                return 0;
            }

            return this.numberWithCommas(this.numberSetPrecision(this.dayOfSharesData[this.dayOfSharesData.length - 1].valuation,0));

		},
        averageSharePrice() {
            var result = 0;
            var capital = this.totalCapital;
            var shares = this.totalShares;
            result = capital / shares;
            return this.numberSetPrecision(result, 2);
        },
        totalCapital() {
            var result = 0;
            for (var i = 0; i < this.investments.length; i++) {
                result += parseInt(this.investments[i].capital);
            }
            return result;
        },
        totalShares() {
            var result = 0;
            for (var i = 0; i < this.investments.length; i++) {
                result += parseInt(this.investments[i].shares);
            }
            return result;
        },
        ...mapGetters(["investorArticles", "investorArticlesCount", "investments", "dayOfSharesData"])
    },

};
</script>
